export default class ForgotCtrl {
	constructor(User,$document,$timeout) {
		this.user = new User({
			email: ''
		});
		this.completed = false;
		$timeout(()=>{
			$document[0].querySelector('[name="email"]').focus()
		})
	}

	requestPasswordReset() {
		this.user.api.requestReset().then(() => {
			this.completed = true;
		});
	};
}
ForgotCtrl.$inject = ['User','$document','$timeout'];



// WEBPACK FOOTER //
// ./project/pages/forgot/forgot.controller.js